// The Sentry SDK for every page, its own bundle: /build/telemetry.js, loaded before the page's bundle
// with data-app="pubgolf". Reports go to /api/errors on this server, which forwards
// them to Bugsink with the real DSN; the DSN below is a placeholder the server replaces.
import { addBreadcrumb, captureException, init, setTag } from '@sentry/browser';

import { TELEMETRY_GLOBAL, type TelemetryApi } from '../common/telemetry.ts';

declare const __PG_RELEASE__: string;

try {
  const script = document.currentScript;
  const app = script?.getAttribute('data-app') || 'web';
  init({
    dsn: `${location.protocol}//relay@${location.host}/0`,
    tunnel: '/api/errors',
    release: __PG_RELEASE__ || undefined,
    environment: __PG_RELEASE__ ? 'production' : 'development',
    integrations: (defaults) => defaults.filter((integration) => integration.name !== 'BrowserSession'),
    sendClientReports: false,
    allowUrls: [location.origin],
    maxBreadcrumbs: 50,
    initialScope: { tags: { app } },
    // Game links are keys: never send them.
    beforeSend: (event) => {
      if (event.request?.url) event.request.url = event.request.url.replace(/\/g\/[A-Za-z0-9_-]+/g, '/g/<token>');
      return event;
    },
    beforeBreadcrumb: (crumb) => {
      if (crumb.data && typeof crumb.data.url === 'string') crumb.data.url = crumb.data.url.replace(/\/g\/[A-Za-z0-9_-]+/g, '/g/<token>');
      if (crumb.data && typeof crumb.data.to === 'string') crumb.data.to = crumb.data.to.replace(/\/g\/[A-Za-z0-9_-]+/g, '/g/<token>');
      if (crumb.data && typeof crumb.data.from === 'string') crumb.data.from = crumb.data.from.replace(/\/g\/[A-Za-z0-9_-]+/g, '/g/<token>');
      return crumb;
    },
  });
  const api: TelemetryApi = {
    report: (error, tags) => {
      captureException(error, tags ? { tags } : undefined);
    },
    tag: (name, value) => {
      setTag(name, value === null ? undefined : value);
    },
    note: (message, level) => {
      addBreadcrumb({ category: 'app', message, level });
    },
  };
  (window as unknown as Record<string, TelemetryApi>)[TELEMETRY_GLOBAL] = api;
} catch {
  // The app runs on without error reports.
}
